import { createSlice } from "@reduxjs/toolkit";
import { Socket } from "socket.io-client";
import { DefaultEventsMap } from "@socket.io/component-emitter";
import { Client } from "webstomp-client";

export interface IMasterState {
  socket: Socket<DefaultEventsMap, DefaultEventsMap> | undefined;
  mqttClient: Client | undefined;
}

const initialState: IMasterState = {
  socket: undefined,
  mqttClient: undefined,
};

const SocketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocket: (state, action) => ({
      ...state,
      socket: action.payload,
    }),
    setMQTT: (state, action) => ({
      ...state,
      mqttClient: action.payload,
    }),
  },
});

export const { setSocket, setMQTT } = SocketSlice.actions;
export default SocketSlice;
